import { defineMessages } from 'react-intl';

export const fallbackRDEHeadlines = defineMessages({
  sectionTitle: {
    defaultMessage: 'Empfehlungen für dich',
    id: 'detailview.grid.headline.recommendation',
  },
  prudSysFallback: {
    defaultMessage: 'Andere Kunden interessierte auch',
    id: 'rde.prudsys.headline-fallback',
  },
  criteoFallback: {
    defaultMessage: 'Gesponserte Artikel',
    id: 'rde.criteo-products.headline-fallback',
  },
  seriesFallback: {
    defaultMessage: 'Mehr aus dieser Serie',
    id: 'rde.series.headline-fallback',
  },
});
